var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top10-drink-bar-chart"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('yin_pin_bang_dan'))+" Top10")]),_c('div',{staticClass:"chart",attrs:{"id":"top10DrinkBarChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }